<div class="text-center">
  <h1 mat-dialog-title>Sign In</h1>
  <div mat-dialog-content class="auth-position">
    <ngx-auth-firebaseui-providers
    [providers]="[providers.Google, providers.Facebook]" 
    layout="column"
    (onSuccess)="loginSuccess($event)"
    (onError)="loginError($event)">
    </ngx-auth-firebaseui-providers>
  </div>
</div>